<form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
  <div [class.dropdown-label-left]="!labelTop">
    <label for="userID-field" class="form-label">User</label>
    <ng-select
      appendTo="body"
      bindLabel="description"
      bindValue="id"
      [clearable]="true"
      formControlName="userID"
      [items]="getDropdownDataObjectArray()"
      id="userID-field"
      [placeholder]="firstUserOption || ''"
      [searchable]="true"
      (change)="selectOnChange($event)"
    ></ng-select>
  </div>
</form>
